export default __webpack_public_path__ + "static/media/marcageo+.296c3f6c.png";